import { RefObject, useLayoutEffect, useRef, useState } from 'react';

// The rendered height of an element, kept current through ResizeObserver. Where that API
// is missing (jsdom) the fallback is returned instead, so callers can reserve a sensible
// fixed amount.
export default function useElementHeight<T extends HTMLElement>(
  fallback: number,
): [RefObject<T>, number] {
  const ref = useRef<T>(null);
  const [height, setHeight] = useState(fallback);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const update = () =>
      setHeight(Math.round(el.getBoundingClientRect().height));
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return [ref, height];
}
